import { strings } from "@/constants";

export const formatDateHandler = (isoDate: string): string => {
    try {
        return new Date(isoDate).toLocaleDateString(
            undefined,
            {
                day: strings.dateFormat.day,
                month: strings.dateFormat.month,
                year: strings.dateFormat.year,
            },
        );
    } catch {
        return isoDate;
    }
};
